// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Activity from "./activity.js"
import Competition from "./competition.js"
import Survey from "./survey.js"
import Team from "./team.js"
import User from "./user.js"
import UserElement from "./user-element.js"
import UserStep from "./user-step.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "feedback_state": {
      "column": {
        "default": "has_none",
        "name": "feedback_state",
        "null": false,
        "type": "string"
      },
      "name": "feedback_state",
      "selected_by_default": null,
      "translated": null
    },
    "finished_at": {
      "column": {
        "default": null,
        "name": "finished_at",
        "null": true,
        "type": "datetime"
      },
      "name": "finished_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "started_at": {
      "column": {
        "default": null,
        "name": "started_at",
        "null": true,
        "type": "datetime"
      },
      "name": "started_at",
      "selected_by_default": null,
      "translated": null
    },
    "state": {
      "column": {
        "default": "unfinished",
        "name": "state",
        "null": true,
        "type": "string"
      },
      "name": "state",
      "selected_by_default": null,
      "translated": null
    },
    "survey_id": {
      "column": {
        "default": null,
        "name": "survey_id",
        "null": true,
        "type": "uuid"
      },
      "name": "survey_id",
      "selected_by_default": null,
      "translated": null
    },
    "team_id": {
      "column": {
        "default": null,
        "name": "team_id",
        "null": true,
        "type": "uuid"
      },
      "name": "team_id",
      "selected_by_default": null,
      "translated": null
    },
    "total_score": {
      "column": {
        "default": 0,
        "name": "total_score",
        "null": false,
        "type": "integer"
      },
      "name": "total_score",
      "selected_by_default": null,
      "translated": null
    },
    "translated_state": {
      "column": null,
      "name": "translated_state",
      "selected_by_default": null,
      "translated": null
    },
    "user_steps_count": {
      "column": {
        "default": 0,
        "name": "user_steps_count",
        "null": false,
        "type": "integer"
      },
      "name": "user_steps_count",
      "selected_by_default": null,
      "translated": null
    },
    "current_user_step_id": {
      "column": {
        "default": null,
        "name": "current_user_step_id",
        "null": true,
        "type": "uuid"
      },
      "name": "current_user_step_id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "TeamSurvey",
  "collectionKey": "team_surveys",
  "collectionName": "team_surveys",
  "i18nKey": "team_survey",
  "camelizedLower": "teamSurvey",
  "name": "TeamSurvey",
  "nameDasherized": "team-survey",
  "pluralName": "team_surveys",
  "ransackable_associations": [
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "activity_id",
      "name": "activity",
      "macro": "has_one",
      "resource_name": "Activity",
      "through": "team"
    },
    {
      "className": "Answer",
      "collectionName": "answers",
      "foreignKey": "user_element_id",
      "name": "answers",
      "macro": "has_many",
      "resource_name": "Answer",
      "through": "user_elements"
    },
    {
      "className": "ClassStep",
      "collectionName": "class_steps",
      "foreignKey": "class_step_id",
      "name": "class_step",
      "macro": "has_one",
      "resource_name": "ClassStep",
      "through": "school_class"
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "organization_id",
      "name": "commune",
      "macro": "has_one",
      "resource_name": "Organization",
      "through": "school"
    },
    {
      "className": "Competition",
      "collectionName": "competitions",
      "foreignKey": "competition_id",
      "name": "competition",
      "macro": "has_one",
      "resource_name": "Competition",
      "through": "team"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "person_id",
      "name": "contacts",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": "users"
    },
    {
      "className": "UserStep",
      "collectionName": "user_steps",
      "foreignKey": "current_user_step_id",
      "name": "current_user_step",
      "macro": "belongs_to",
      "resource_name": "UserStep",
      "through": null
    },
    {
      "className": "ElementFeedback",
      "collectionName": "element_feedbacks",
      "foreignKey": "element_id",
      "name": "element_feedbacks",
      "macro": "has_many",
      "resource_name": "ElementFeedback",
      "through": "user_elements"
    },
    {
      "className": "FeedbackAssignment",
      "collectionName": "feedback_assignments",
      "foreignKey": "team_survey_id",
      "name": "feedback_assignments",
      "macro": "has_many",
      "resource_name": "FeedbackAssignment",
      "through": null
    },
    {
      "className": "FeedbackAssignment",
      "collectionName": "feedback_assignments",
      "foreignKey": "team_survey_to_feedback_id",
      "name": "feedback_from_assignments",
      "macro": "has_many",
      "resource_name": "FeedbackAssignment",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "location_id",
      "name": "location",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": "activity"
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "UserStep",
      "collectionName": "user_steps",
      "foreignKey": "team_survey_id",
      "name": "next_user_step",
      "macro": "has_one",
      "resource_name": "UserStep",
      "through": null
    },
    {
      "className": "Person",
      "collectionName": "people",
      "foreignKey": "person_id",
      "name": "people",
      "macro": "has_many",
      "resource_name": "Person",
      "through": "users"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "parent_id",
      "name": "region",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": "school_contact"
    },
    {
      "className": "Organization",
      "collectionName": "organizations",
      "foreignKey": "school_id",
      "name": "school",
      "macro": "has_one",
      "resource_name": "Organization",
      "through": "team"
    },
    {
      "className": "SchoolClass",
      "collectionName": "school_classes",
      "foreignKey": "school_class_id",
      "name": "school_class",
      "macro": "has_one",
      "resource_name": "SchoolClass",
      "through": "team"
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "organization_id",
      "name": "school_contact",
      "macro": "has_one",
      "resource_name": "Contact",
      "through": "school"
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    },
    {
      "className": "SurveyJudge",
      "collectionName": "survey_judges",
      "foreignKey": "survey_id",
      "name": "survey_judges",
      "macro": "has_many",
      "resource_name": "SurveyJudge",
      "through": "survey"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "team_id",
      "name": "team",
      "macro": "belongs_to",
      "resource_name": "Team",
      "through": null
    },
    {
      "className": "TeamSurveyJudgeReview",
      "collectionName": "team_survey_judge_reviews",
      "foreignKey": "team_survey_id",
      "name": "team_survey_judge_reviews",
      "macro": "has_many",
      "resource_name": "TeamSurveyJudgeReview",
      "through": null
    },
    {
      "className": "TeamUser",
      "collectionName": "team_users",
      "foreignKey": "team_id",
      "name": "team_users",
      "macro": "has_many",
      "resource_name": "TeamUser",
      "through": "team"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "UserElement",
      "collectionName": "user_elements",
      "foreignKey": "user_step_id",
      "name": "user_elements",
      "macro": "has_many",
      "resource_name": "UserElement",
      "through": "user_steps"
    },
    {
      "className": "UserStep",
      "collectionName": "user_steps",
      "foreignKey": "team_survey_id",
      "name": "user_steps",
      "macro": "has_many",
      "resource_name": "UserStep",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "users",
      "macro": "has_many",
      "resource_name": "User",
      "through": "team"
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "current_user_step_id",
      "column": {
        "default": null,
        "name": "current_user_step_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "feedback_state",
      "column": {
        "default": "has_none",
        "name": "feedback_state",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "finished_at",
      "column": {
        "default": null,
        "name": "finished_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "old_id",
      "column": {
        "default": null,
        "name": "old_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_survey_id",
      "column": {
        "default": null,
        "name": "old_survey_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "old_team_id",
      "column": {
        "default": null,
        "name": "old_team_id",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "started_at",
      "column": {
        "default": null,
        "name": "started_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "state",
      "column": {
        "default": "unfinished",
        "name": "state",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "survey_id",
      "column": {
        "default": null,
        "name": "survey_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "team_id",
      "column": {
        "default": null,
        "name": "team_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "timed_out_at",
      "column": {
        "default": null,
        "name": "timed_out_at",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "total_score",
      "column": {
        "default": 0,
        "name": "total_score",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "user_steps_count",
      "column": {
        "default": 0,
        "name": "user_steps_count",
        "null": false,
        "type": "integer"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    },
    {
      "name": "with_user"
    }
  ],
  "relationships": [
    {
      "className": "Activity",
      "collectionName": "activities",
      "foreignKey": "activity_id",
      "name": "activity",
      "macro": "has_one",
      "resource_name": "Activity",
      "through": "team"
    },
    {
      "className": "Competition",
      "collectionName": "competitions",
      "foreignKey": "competition_id",
      "name": "competition",
      "macro": "has_one",
      "resource_name": "Competition",
      "through": "team"
    },
    {
      "className": "UserStep",
      "collectionName": "user_steps",
      "foreignKey": "current_user_step_id",
      "name": "current_user_step",
      "macro": "belongs_to",
      "resource_name": "UserStep",
      "through": null
    },
    {
      "className": "UserStep",
      "collectionName": "user_steps",
      "foreignKey": "team_survey_id",
      "name": "next_user_step",
      "macro": "has_one",
      "resource_name": "UserStep",
      "through": null
    },
    {
      "className": "Survey",
      "collectionName": "surveys",
      "foreignKey": "survey_id",
      "name": "survey",
      "macro": "belongs_to",
      "resource_name": "Survey",
      "through": null
    },
    {
      "className": "Team",
      "collectionName": "teams",
      "foreignKey": "team_id",
      "name": "team",
      "macro": "belongs_to",
      "resource_name": "Team",
      "through": null
    },
    {
      "className": "User",
      "collectionName": "users",
      "foreignKey": "user_id",
      "name": "users",
      "macro": "has_many",
      "resource_name": "User",
      "through": "team"
    },
    {
      "className": "UserElement",
      "collectionName": "user_elements",
      "foreignKey": "user_step_id",
      "name": "user_elements",
      "macro": "has_many",
      "resource_name": "UserElement",
      "through": "user_steps"
    },
    {
      "className": "UserStep",
      "collectionName": "user_steps",
      "foreignKey": "team_survey_id",
      "name": "user_steps",
      "macro": "has_many",
      "resource_name": "UserStep",
      "through": null
    }
  ],
  "paramKey": "team_survey",
  "primaryKey": "id"
}

/** Frontend model for TeamSurvey. */
export default class TeamSurvey extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  feedbackState() {
    return this.readAttributeUnderscore("feedback_state")
  }

  /** @returns {boolean} */
  hasFeedbackState() {
    const value = this.feedbackState()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  finishedAt() {
    return this.readAttributeUnderscore("finished_at")
  }

  /** @returns {boolean} */
  hasFinishedAt() {
    const value = this.finishedAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  startedAt() {
    return this.readAttributeUnderscore("started_at")
  }

  /** @returns {boolean} */
  hasStartedAt() {
    const value = this.startedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  state() {
    return this.readAttributeUnderscore("state")
  }

  /** @returns {boolean} */
  hasState() {
    const value = this.state()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  surveyId() {
    return this.readAttributeUnderscore("survey_id")
  }

  /** @returns {boolean} */
  hasSurveyId() {
    const value = this.surveyId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  teamId() {
    return this.readAttributeUnderscore("team_id")
  }

  /** @returns {boolean} */
  hasTeamId() {
    const value = this.teamId()

    return this._isPresent(value)
  }

  /** @returns {number} */
  totalScore() {
    return this.readAttributeUnderscore("total_score")
  }

  /** @returns {boolean} */
  hasTotalScore() {
    const value = this.totalScore()

    return this._isPresent(value)
  }

  /** @returns {any} */
  translatedState() {
    return this.readAttributeUnderscore("translated_state")
  }

  /** @returns {boolean} */
  hasTranslatedState() {
    const value = this.translatedState()

    return this._isPresent(value)
  }

  /** @returns {number} */
  userStepsCount() {
    return this.readAttributeUnderscore("user_steps_count")
  }

  /** @returns {boolean} */
  hasUserStepsCount() {
    const value = this.userStepsCount()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  currentUserStepId() {
    return this.readAttributeUnderscore("current_user_step_id")
  }

  /** @returns {boolean} */
  hasCurrentUserStepId() {
    const value = this.currentUserStepId()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  finish(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "finish",
        primaryKey: this.primaryKey(),
        collectionName: "team_surveys",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  nextStep(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "next_step",
        primaryKey: this.primaryKey(),
        collectionName: "team_surveys",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  setCurrentUserStep(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "set_current_user_step",
        primaryKey: this.primaryKey(),
        collectionName: "team_surveys",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  start(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "start",
        primaryKey: this.primaryKey(),
        collectionName: "team_surveys",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./activity.js").default | null} */
  activity() {
    return this._readHasOneReflection({modelClass: Activity, reflectionName: "activity"})
  }

  /** @returns {Promise<import("./activity.js").default | null>} */
  loadActivity() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "activity",
        model: this,
        modelClass: Activity
      },
      {
        params: {
          through: {
            model: "TeamSurvey",
            id,
            reflection: "activity"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./activity.js").default | null>} */
  ensureActivityLoaded() {
    return this.ensureAssociationLoaded("activity")
  }

  /** @returns {import("./competition.js").default | null} */
  competition() {
    return this._readHasOneReflection({modelClass: Competition, reflectionName: "competition"})
  }

  /** @returns {Promise<import("./competition.js").default | null>} */
  loadCompetition() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()

    return this._loadHasOneReflection(
      {
        reflectionName: "competition",
        model: this,
        modelClass: Competition
      },
      {
        params: {
          through: {
            model: "TeamSurvey",
            id,
            reflection: "competition"
          }
        }
      }
    )
  }

  /** @returns {Promise<import("./competition.js").default | null>} */
  ensureCompetitionLoaded() {
    return this.ensureAssociationLoaded("competition")
  }

  /** @returns {import("./user-step.js").default | null} */
  currentUserStep() {
    return this._readBelongsToReflection({modelClass: UserStep, reflectionName: "current_user_step"})
  }

  /** @returns {Promise<import("./user-step.js").default | null>} */
  loadCurrentUserStep() {
    if (!("currentUserStepId" in this)) throw new Error("Foreign key method wasn't defined: currentUserStepId")

    const id = this.currentUserStepId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "current_user_step",
        model: this,
        modelClass: UserStep
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./user-step.js").default | null>} */
  ensureCurrentUserStepLoaded() {
    return this.ensureAssociationLoaded("current_user_step")
  }

  /** @returns {import("./user-step.js").default | null} */
  nextUserStep() {
    return this._readHasOneReflection({modelClass: UserStep, reflectionName: "next_user_step"})
  }

  /** @returns {Promise<import("./user-step.js").default | null>} */
  loadNextUserStep() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["team_survey_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "next_user_step",
        model: this,
        modelClass: UserStep
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./user-step.js").default | null>} */
  ensureNextUserStepLoaded() {
    return this.ensureAssociationLoaded("next_user_step")
  }

  /** @returns {import("./survey.js").default | null} */
  survey() {
    return this._readBelongsToReflection({modelClass: Survey, reflectionName: "survey"})
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  loadSurvey() {
    if (!("surveyId" in this)) throw new Error("Foreign key method wasn't defined: surveyId")

    const id = this.surveyId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "survey",
        model: this,
        modelClass: Survey
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./survey.js").default | null>} */
  ensureSurveyLoaded() {
    return this.ensureAssociationLoaded("survey")
  }

  /** @returns {import("./team.js").default | null} */
  team() {
    return this._readBelongsToReflection({modelClass: Team, reflectionName: "team"})
  }

  /** @returns {Promise<import("./team.js").default | null>} */
  loadTeam() {
    if (!("teamId" in this)) throw new Error("Foreign key method wasn't defined: teamId")

    const id = this.teamId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "team",
        model: this,
        modelClass: Team
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./team.js").default | null>} */
  ensureTeamLoaded() {
    return this.ensureAssociationLoaded("team")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./user.js").default>} */
  users() {
    return new Collection(
      {
        reflectionName: "users",
        model: this,
        modelClass: User
      },
      {
        params: {
          through: {
            model: "TeamSurvey",
            id: this.primaryKey(),
            reflection: "users"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./user.js").default>>} */
  loadUsers() {
    return this._loadHasManyReflection(
      {
        reflectionName: "users",
        model: this,
        modelClass: User
      },
      {
        params: {
          through: {
            model: "TeamSurvey",
            id: this.primaryKey(),
            reflection: "users"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./user.js").default>>} */
  ensureUsersLoaded() {
    return this.ensureAssociationLoaded("users")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./user-element.js").default>} */
  userElements() {
    return new Collection(
      {
        reflectionName: "user_elements",
        model: this,
        modelClass: UserElement
      },
      {
        params: {
          through: {
            model: "TeamSurvey",
            id: this.primaryKey(),
            reflection: "user_elements"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./user-element.js").default>>} */
  loadUserElements() {
    return this._loadHasManyReflection(
      {
        reflectionName: "user_elements",
        model: this,
        modelClass: UserElement
      },
      {
        params: {
          through: {
            model: "TeamSurvey",
            id: this.primaryKey(),
            reflection: "user_elements"
          }
        }
      }
    )
  }

  /** @returns {Promise<Array<import("./user-element.js").default>>} */
  ensureUserElementsLoaded() {
    return this.ensureAssociationLoaded("user_elements")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./user-step.js").default>} */
  userSteps() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["team_survey_id_eq"] = this.id()

    return new Collection(
      {
        reflectionName: "user_steps",
        model: this,
        modelClass: UserStep
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./user-step.js").default>>} */
  loadUserSteps() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["team_survey_id_eq"] = this.id()

    return this._loadHasManyReflection(
      {
        reflectionName: "user_steps",
        model: this,
        modelClass: UserStep
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./user-step.js").default>>} */
  ensureUserStepsLoaded() {
    return this.ensureAssociationLoaded("user_steps")
  }
}
